import * as React from 'react';

import { VAR_ID } from '../constEventHandlers';

import FormControlWrapper from 'kiini/FormControlWrapper';
import ArgumentValueSelect from '../widgets/ArgumentValueSelect';

const IndependentGeoTriggerConditionWidget = ({ id, instance, label, eventName, store }) => {

    
    const selectOptions = store.experience.geoTriggers.filter(geoTrigger => (geoTrigger.contentObjectLinkId == null)).map(geoTrigger => { 
        return {value: geoTrigger.id, label: geoTrigger.name };
    });

    return <FormControlWrapper label={label} showError={false}>
        <ArgumentValueSelect
            instance={instance}
            fieldName="values"
            argumentName={VAR_ID}
            selectOptions={selectOptions} />
    </FormControlWrapper>


    

}

export default IndependentGeoTriggerConditionWidget;